import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTenantTranslation } from "hooks/formatters";
import { InventoryMeasurementForm } from "./measurement/InventoryMeasurementForm";
import { InventoryMeasurementProvider } from "./measurement/InventoryMeasurementProvider";
import { InventoryMeasurementWithLocationsProvider } from "./measurement/InventoryMeasurementWithLocationsProvider";
import { InventoryMeasurementWithLocationsForm } from "./measurement/InventoryMeasurementWithLocationsFormDesktop";
import { InventoryMeasurementUploadGateway } from "./measurement/InventoryMeasurementUploadGateway";
import { InventoryReportUploadGateway } from "./measurement/InventoryReportUploadGateway";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";

export const InventoryManagementPage: React.FC = () => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isInventoryMeasurementWithLocationsEnabled = useIsBehindFeatureFlag(
    "inventory_measurement_with_locations"
  );
  const isInventoryUploadGatewayEnabled = useIsBehindFeatureFlag(
    "inventory_upload_gateway"
  );

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          maxWidth: isMobile ? "90vw" : "50vw",
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="h1" gutterBottom sx={{ mb: 2 }}>
          {t("inventory")}
        </Typography>
        {isInventoryMeasurementWithLocationsEnabled &&
        isInventoryUploadGatewayEnabled ? (
          <InventoryMeasurementUploadGateway>
            <InventoryMeasurementWithLocationsProvider>
              <InventoryMeasurementWithLocationsForm />
            </InventoryMeasurementWithLocationsProvider>
          </InventoryMeasurementUploadGateway>
        ) : isInventoryMeasurementWithLocationsEnabled ? (
          <InventoryMeasurementWithLocationsProvider>
            <InventoryMeasurementWithLocationsForm />
          </InventoryMeasurementWithLocationsProvider>
        ) : isInventoryUploadGatewayEnabled ? (
          <InventoryReportUploadGateway>
            <InventoryMeasurementProvider>
              <InventoryMeasurementForm />
            </InventoryMeasurementProvider>
          </InventoryReportUploadGateway>
        ) : (
          <InventoryMeasurementProvider>
            <InventoryMeasurementForm />
          </InventoryMeasurementProvider>
        )}
      </Box>
    </Box>
  );
};
